// SUN-105: "Open page" on a page-note card starts a review; the bar in AppShell shows it. No API calls here.
import { useSyncExternalStore } from 'react';
import type { ApprovalNote } from '../types';

let current: ApprovalNote | null = null;
const listeners = new Set<() => void>();
const emit = () => { for (const l of listeners) l(); };

export function startReview(note: ApprovalNote): void { current = note; emit(); }
export function endReview(): void { if (current) { current = null; emit(); } }
export function getReview(): ApprovalNote | null { return current; }
const subscribe = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };
export function useReview(): ApprovalNote | null { return useSyncExternalStore(subscribe, getReview, getReview); }
